// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"stacks_wrapper__YGcPq","suggestion":"stacks_suggestion__2BmvQ"};